import { Highlight, Snippet } from 'react-instantsearch-dom';

import FontIcon from 'components/icons';
import Link from 'components/link/link';

import './styles/blog-search.scss';
const ListItem = ({ hit }) => {
  return (
    <li className="search-list-item">
      <FontIcon icon="document" />
      <Link to={ `/blog/${hit.slug}` } className="link-title">
        <h4>
          <Highlight attribute="title" hit={ hit } tagName="mark" />
        </h4>
      </Link>
      <Link to={ `/blog/${hit.slug}` } className="link-content">
        <Snippet attribute="content" hit={ hit } tagName="mark" />
      </Link>
    </li>
  );
};
export default ListItem;
